import React, { useEffect, useCallback } from 'react';
import { injectedComponent, useText } from '@base/core';
import { useUrlParams } from '../hooks/useUrlParams';
import { CONFIRM_TOKEN_ACTIONS } from '../configs/constants';
import { SESSION_KEY_SUCCESS } from '@base/constants/sessionKey';

export default injectedComponent(
  {
    name: 'SuccessParamDetector',
    services: ['notifier'],
  },
  function SuccessParamDetector({
    services: { notifier },
  }) {
    const text = useText();
    const { removeUrlParams } = useUrlParams();
    const searchParams = new URLSearchParams(window.location.search);

    const handleSuccessfulOperation = useCallback((searchParams) => {
      const checkResult = searchParams.get('checkResult');
      const action = searchParams.get('action');
      const error = searchParams.get('error');

      if (error || checkResult !== SESSION_KEY_SUCCESS.CHECK_RESULT_SUCCESS) return false;

      if (action === CONFIRM_TOKEN_ACTIONS.CHANGE_PASSWORD) {
        setTimeout(() => {
          notifier.push(text('dialog.session_key.notification__password_changed'), {
            type: 'success',
            timeless: true,
          });
        }, 100);
      }

      removeUrlParams(SESSION_KEY_SUCCESS.SESSION_PARAMS_TO_REMOVE);
      return true;
    }, [removeUrlParams, notifier, text]);

    useEffect(() => {
      if (!searchParams.get('checkResult')) return;

      handleSuccessfulOperation(searchParams);
    }, [handleSuccessfulOperation, searchParams]);

    return null;
  },
);

